export const isEntriesStrings = (mainStr, subStr) =>
  String(mainStr).toLowerCase().includes(String(subStr).toLowerCase())
export const capitalize = s => s && s[0].toUpperCase() + s.slice(1)
